import { onStartIntro } from './intro-overlay';

class HomeIntro {
    constructor() {
        this.title = document.querySelector('.home-intro .title');
        if (!this.title) return;

        this.splitWords();

        // Build the timeline right away so the words are hidden (from-tweens render their start state), play it on intro
        const tl = this.animateWords();
        onStartIntro(() => gsap.delayedCall(0.6, () => tl.play()));
    }

    splitWords() {
        let sentenceIndex = 0;

        const wrapText = (node) => {
            const fragment = document.createDocumentFragment();

            node.childNodes.forEach((child) => {
                if (child.nodeType === Node.TEXT_NODE) {
                    child.textContent.split(/(\s+)/).forEach((part) => {
                        if (part === '') return;

                        if (/^\s+$/.test(part)) {
                            fragment.appendChild(document.createTextNode(part));
                        } else {
                            const span = document.createElement('span');
                            span.className = 'word';
                            span.dataset.sentence = sentenceIndex;
                            span.textContent = part;
                            fragment.appendChild(span);

                            if (part.includes('.')) {
                                sentenceIndex++;
                            }
                        }
                    });
                } else if (child.nodeType === Node.ELEMENT_NODE) {
                    const clone = child.cloneNode(false);
                    clone.appendChild(wrapText(child));
                    fragment.appendChild(clone);
                }
            });

            return fragment;
        };

        const wrapped = wrapText(this.title);
        this.title.innerHTML = '';
        this.title.appendChild(wrapped);

        this.sentenceCount = sentenceIndex + 1;
    }

    animateWords() {
        const tl = gsap.timeline({ paused: true });

        for (let i = 0; i < this.sentenceCount; i++) {
            const words = this.title.querySelectorAll(`.word[data-sentence="${i}"]`);
            if (!words.length) continue;

            tl.from(
                words,
                {
                    opacity: 0,
                    y: 10,
                    duration: 0.8,
                    ease: 'power1.out',
                    stagger: 0.05
                },
                i === 0 ? 0 : '+=0.1'
            );
        }

        return tl;
    }
}
new HomeIntro();
